var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Toast'), _c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Content Recommendation'
      }],
      "title": "All Content Recommendation"
    }
  }), _c('div', {
    staticClass: "bg-white content-recomendation block rounded-lg shadow-sm"
  }, [_c('div', {
    staticClass: "flex w-1/2 p-10"
  }, [_c('span', {
    staticClass: "inline-flex text-xs border-l border-t border-b items-center px-3 text-gray-900 bg-gray-200 rounded-tl-md rounded-bl-md border-gray-300 border-e-0 rounded-s-md dark:bg-gray-600 dark:text-gray-400 dark:border-gray-600"
  }, [_vm._v(" RECOMMENDATION TITLE ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query_search,
      expression: "query_search"
    }],
    staticClass: "rounded-br-md rounded-tr-md border-r border-t border-b rounded-e-lg bg-gray-50 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
    attrs: {
      "placeholder": "Search",
      "type": "text",
      "id": "website-admin"
    },
    domProps: {
      "value": _vm.query_search
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.query_search = $event.target.value;
      }, _vm.setQuerySearch],
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getListRecomendasi.apply(null, arguments);
      }
    }
  })]), _c('div', {
    staticClass: "relative"
  }, [_c('div', [_c('table', {
    staticClass: "w-full text-sm text-gray-500 text-left rtl:text-right bg-white dark:text-gray-400"
  }, [_c('thead', {
    staticClass: "text-xs text-gray-500 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
  }, [_c('tr', {
    staticClass: "bg-gray-50"
  }, [_c('th', {
    staticClass: "px-6 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Recommendation Title")]), _c('th', {
    staticClass: "px-6 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Description")]), _c('th', {
    staticClass: "px-6 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Content Amount")]), _c('th', {
    staticClass: "px-6 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_c('div', {
    staticClass: "flex items-center cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.sortBy('modified');
      }
    }
  }, [_vm._v(" Last Modified "), _c('span', [_c('svg', {
    staticClass: "w-3 h-3 ms-1.5",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "currentColor",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
    }
  })])])])]), _c('th', {
    staticClass: "px-6 py-3",
    attrs: {
      "scope": "col"
    }
  }, [_c('div', {
    staticClass: "flex items-center cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.sortBy('created');
      }
    }
  }, [_vm._v(" Created Date "), _c('span', [_c('svg', {
    staticClass: "w-3 h-3 ms-1.5",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "currentColor",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
    }
  })])])])]), _c('th', {
    staticClass: "px-6 py-3",
    attrs: {
      "scope": "col"
    }
  })])]), _c('tbody', [_vm.isLoading ? _c('tr', [_c('div', {
    staticClass: "absolute bg-white w- -translate-x-1/2 -translate-y-1/2 top-40 left-1/2",
    attrs: {
      "role": "status"
    }
  }, [_c('svg', {
    staticClass: "w-8 h-8 text-blue-500 animate-spin dark:text-gray-600 fill-blue-600",
    attrs: {
      "aria-hidden": "true",
      "viewBox": "0 0 100 101",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
      "fill": "currentColor"
    }
  }), _c('path', {
    attrs: {
      "d": "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
      "fill": "currentFill"
    }
  })]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])])]) : _vm.items.length === 0 ? _c('tr', [_c('td', {
    staticClass: "px-6 py-4 text-center text-gray-500",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No data available")])]) : _vm._l(_vm.sortedItems, function (data, index) {
    return _c('tr', {
      key: index,
      staticClass: "border-b focus:bg-gray-500",
      class: {
        'active-row bg-gray-200': _vm.selectedIndex === index,
        'bg-white': _vm.selectedIndex !== index,
        'border-b': true
      }
    }, [_c('th', {
      staticClass: "px-6 py-3 font-medium text-gray-500 whitespace-nowrap dark:text-white",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(" " + _vm._s(data.title) + " ")]), _c('p', {
      staticClass: "w-96 mt-3 truncate-2-lines"
    }, [_vm._v(" " + _vm._s((data === null || data === void 0 ? void 0 : data.description) || '-') + " ")]), _c('td', {
      staticClass: "px-6 py-3"
    }, [_c('div', {
      staticClass: "flex"
    }, [_vm._v(" " + _vm._s(data === null || data === void 0 ? void 0 : data.content_count) + " Contents")])]), _c('td', {
      staticClass: "px-6 py-3"
    }, [_vm._v(_vm._s(_vm.formatDate(data === null || data === void 0 ? void 0 : data.modified)))]), _c('td', {
      staticClass: "px-6 py-3"
    }, [_vm._v(_vm._s(_vm.formatDate(data === null || data === void 0 ? void 0 : data.created)))]), _c('td', {
      staticClass: "px-6 py-3 text-right outline-none relative"
    }, [_c('div', {
      staticClass: "navbar-right relative"
    }, [_c('button', {
      staticClass: "inline-flex items-center p-2 text-sm font-medium text-center text-gray-900",
      attrs: {
        "id": "dropdownMenuIconHorizontalButton",
        "type": "button"
      },
      on: {
        "click": function ($event) {
          return _vm.toggleDropdown(index);
        }
      }
    }, [_c('svg', {
      staticClass: "w-5 h-5",
      attrs: {
        "aria-hidden": "true",
        "xmlns": "http://www.w3.org/2000/svg",
        "fill": "currentColor",
        "viewBox": "0 0 16 3"
      }
    }, [_c('path', {
      attrs: {
        "d": "M2 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm6.041 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM14 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
      }
    })])]), _vm.selectedIndex === index ? _c('div', {
      staticClass: "fixed top-0 inset-0 h-full w-full bg-black opacity-0 cursor-default",
      attrs: {
        "tabindex": "-1"
      },
      on: {
        "click": _vm.closeDropdown
      }
    }) : _vm._e(), _vm.selectedIndex === index ? _c('div', {
      staticClass: "absolute z-10 top-auto right-2 w-48 py-2 mt-2 rounded-lg border-gray-900 bg-white shadow-xl"
    }, [_c('ul', {
      staticClass: "px-2 mb-0 text-sm text-gray-500 dark:text-gray-200",
      attrs: {
        "aria-labelledby": "dropdownMenuIconHorizontalButton"
      }
    }, [_c('li', [_c('router-link', {
      staticClass: "text-gray-500 w-full block list-none",
      attrs: {
        "to": {
          path: ("/content-recommendation/edit/" + (data.id))
        }
      }
    }, [_c('div', {
      staticClass: "flex w-full items-end justify-start px-3 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white text-gray-500 text-left"
    }, [_c('svg', {
      staticClass: "w-6 h-6 text-gray-500 dark:text-white",
      attrs: {
        "aria-hidden": "true",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "fill": "currentColor",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z",
        "clip-rule": "evenodd"
      }
    }), _c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z",
        "clip-rule": "evenodd"
      }
    })]), _c('span', {
      staticClass: "ml-2"
    }, [_vm._v("Edit")])])])], 1), _c('li', [_c('router-link', {
      staticClass: "text-gray-500 w-full block list-none",
      attrs: {
        "to": {
          path: ("/content-recommendation/detail/" + (data.id))
        }
      }
    }, [_c('div', {
      staticClass: "flex w-full items-end justify-start px-3 py-2 hover:bg-gray-100 cursor-pointer text-gray-500 text-left"
    }, [_c('svg', {
      staticClass: "w-6 h-6 text-gray-500 dark:text-white",
      attrs: {
        "aria-hidden": "true",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "fill": "none",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "stroke": "currentColor",
        "stroke-width": "2",
        "d": "M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z"
      }
    }), _c('path', {
      attrs: {
        "stroke": "currentColor",
        "stroke-width": "2",
        "d": "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
      }
    })]), _c('span', {
      staticClass: "ml-2"
    }, [_vm._v("View")])])])], 1)])]) : _vm._e()])])]);
  })], 2)])])])]), _c('div', {
    staticClass: "flex bg-white p-4 mb-5 rounded-bl-lg rounded-br-lg"
  }, [_vm._v(" Showing 1-" + _vm._s(_vm.items.length) + " of " + _vm._s(_vm.items.length) + " ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }